import { createFileRoute } from '@tanstack/react-router'
import {Alert, AlertDescription, AlertTitle} from '@/components/ui/alert'
import {Button} from '@/components/ui/button'
import {Card, CardContent, CardHeader, CardTitle} from '@/components/ui/card'
import {LoadingSpinner} from '@/components/ui/loading'
import {Separator} from '@/components/ui/separator'
import {useEffect, useRef, useState} from 'react'
import {useMutation, useQuery} from '@tanstack/react-query'
import {generateToken, getAllTokens, removeAllToken, removeOneToken} from '@/queries/tokens'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import {Clipboard, Trash} from 'lucide-react'
import {toast} from 'sonner'
import { convertDateTime } from '@/lib/utils'

export const Route = createFileRoute('/client/tokens/')({
  component: ClientTokens,
})


function ClientTokens() {
  const navigate = Route.useNavigate()
  const [tokens, setTokens] = useState<Array<any>>([])
  const [showRemoveAll, setShowRemoveAll] = useState(false)
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)
  const [token, setToken] = useState('')
  const [showModalToken, setShowModalToken] = useState(false)
  const [canDelete, setCanDelete] = useState(false)
  const deleteId = useRef<number>(0)


  const getClientTokens = useQuery({
    queryFn: () => getAllTokens(),
    queryKey: ['prizes', 'client'],
  })

  useEffect(() => {
    if (getClientTokens.data?.data) {
      const { data, additional }: any = getClientTokens.data.data
      const currentToken = additional.currentAccessToken
      const tokens = data.map((d: any) => {
        if (d.token === currentToken) {
          d.isActive = true
        }
        return d
      })
      console.log(tokens)
      setTokens(
        data.map((d: any) => {
          if (d.token === currentToken) {
            d.isActive = true
          }
          return d
        })
      )
    }
  }, [getClientTokens.data])

  const makeTokenMutation = useMutation({
    mutationFn: () => generateToken(),
    mutationKey: ['generate', 'token'],
    onSuccess({ data }) {
      setShowModalToken(true)
      setToken(data.token)
      // setTokens((tokens) => [...tokens, data])
      getClientTokens.refetch()
    },
  })

  const deleteOneToken = useMutation({
    mutationFn: (id: any) => removeOneToken(id),
    mutationKey: ['remove', 'token'],
    onSuccess: (_, variables) => {
      toast.success('دسترسی با موفقیت حذف شد')
      setShowDeleteDialog(false)
      setTokens((tokens) => tokens.filter((t) => t.id !== variables))
    },
  })

  const deleteAllToken = useMutation({
    mutationFn: () => removeAllToken(),
    mutationKey: ['remove', 'all', 'tokens'],
    onSuccess: () => {
      setTokens((tokens) => tokens.filter((r) => !r?.isActive))
      toast.success('تمامی دسترسی ها با موفقیت حذف شد')
      setShowRemoveAll(false)
    },
  })

  const deleteEnable = (open: boolean) => {
    setShowRemoveAll(open)
    if (open) {
      setTimeout(() => {
        setCanDelete(true)
      }, 2000)
    } else {
      setCanDelete(false)
    }
  }

  const handleCopy = (token: any) => {
    navigator.clipboard.writeText(token).then(() => {
      toast.success('کپی شد')
    }).catch(e => {
      toast.error(JSON.stringify(e))
    })
  }

  return (
    <>
      <Card>
        <CardHeader className='flex flex-row items-center justify-between'>
          <CardTitle>دسترسی ها</CardTitle>
          <Button onClick={() => navigate({ to: '/' })}>بازگشت</Button>
        </CardHeader>
        <Separator className='mb-4' />
        <CardContent>
          <div className='flex gap-2'>
            <Dialog open={showModalToken} onOpenChange={setShowModalToken}>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>دسترسی جدید</DialogTitle>
                </DialogHeader>
                <div className='sm:max-w-lg'>
                  <div className='flex mb-4'>
                    <code className='w-72 code truncate'>{token}</code>
                    <Clipboard onClick={() => handleCopy(token)} className='cursor-pointer' />
                  </div>
                  <Alert variant='destructive'>
                    <AlertTitle>نکته مهم:</AlertTitle>
                    <AlertDescription>
                      در نگه داری این توکن کوشا باشید و برای خود ذخیره کنید ٫ در صورت گم کردن ٫ مجدد
                      برای خود توکن جدید ایجاد کنید.
                    </AlertDescription>
                  </Alert>
                </div>
                <DialogFooter className='flex gap-2'>
                  <Button onClick={() => setShowModalToken(false)}>بستن</Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
            <Button
              isLoading={makeTokenMutation.isPending}
              onClick={() => makeTokenMutation.mutate()}
              variant='outline'
            >
              ایجاد دسترسی جدید
            </Button>
            <Dialog open={showRemoveAll} onOpenChange={deleteEnable}>
              <DialogTrigger>
                <Button>حذف تمامی دسترسی ها</Button>
              </DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>حذف تمامی دسترسی ها</DialogTitle>
                </DialogHeader>
                <div className='sm:max-w-lg'>
                  <p>
                    آیا از حذف تمامی دسترسی ها اطمینان دارید ؟ بعد از انجام این کار دسترسی تمام
                    برنامه های شما به وب سرویس غیرفعال گردیده و این عملیات غیر قابل بازگشت می باشد
                  </p>
                </div>
                <DialogFooter className='flex gap-2'>
                  <Button variant='outline' onClick={() => setShowRemoveAll(false)}>
                    لغو
                  </Button>
                  <Button
                    disabled={!canDelete || deleteAllToken.isPending}
                    onClick={() => deleteAllToken.mutate()}
                  >
                    تایید
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>

            <Dialog open={showDeleteDialog} onOpenChange={(o) => setShowDeleteDialog(o)}>
              <DialogTrigger></DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>حذف دسترسی</DialogTitle>
                </DialogHeader>

                <div className='sm:max-w-lg'>
                  بعد از حذف این دسترسی تمامی برنامه های متصل به این دسترسی غیر فعال خواهند شد و
                  دیگر نمی توانند با وب سرویس ما ارتباط داشته باشند. آیا از حذف این دسترسی اطمینان
                  دارید؟
                </div>

                <DialogFooter>
                  <Button
                    onClick={() => deleteOneToken.mutate(deleteId.current)}
                    isLoading={deleteOneToken.isPending}
                    disabled={deleteOneToken.isPending}
                  >
                    تایید
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          </div>
          {getClientTokens.isLoading ? (
            <LoadingSpinner />
          ) : tokens.length < 1 ? (
            <>
              <Alert className='my-3'>هیچ دسترسی وجود ندارد</Alert>
            </>
          ) : (
            <>
              <Table>
                <TableHeader>
                  <TableHead className='text-right'>آخرین استفاده</TableHead>
                  <TableHead className='text-right'>تاریخ ایجاد</TableHead>
                  <TableHead></TableHead>
                </TableHeader>

                <TableBody>
                  {tokens.map((token: any) => (
                    <>
                      <TableRow
                        className={`${token?.isActive && 'bg-red-400 text-white hover:bg-red-500'}`}
                      >
                        <TableCell dir='ltr' className='text-right'>
                          {token?.last_used_at === null
                            ? '-'
                            : convertDateTime(token?.last_used_at)}
                        </TableCell>
                        <TableCell dir='ltr' className='text-right'>
                          {convertDateTime(token?.created_at)}
                        </TableCell>
                        <TableCell>
                          {!token?.isActive ? (
                            <Button
                              onClick={() => {
                                setShowDeleteDialog(true)
                                deleteId.current = token.id
                              } }
                              className='p-2'
                            >
                              <Trash />
                            </Button>
                          ) : (
                            'دسترسی فعلی شما'
                          )}
                        </TableCell>
                      </TableRow>
                    </>
                  ))}
                </TableBody>
              </Table>
            </>
          )}
        </CardContent>
      </Card>
    </>
  )
}
